import { api } from '@/api'

export interface TransactionTransferAdmin {
  id: string
  fullName: string
}

export interface TransactionTransferChanges {
  amount: number
  exchange_rate: number
  seller_bank_account: string
  seller_bank_account_country: string
  seller_transfer_methods: number[]
  buyer_transfer_methods: number[]
}

export interface TransactionTransferTransaction {
  id: string
  code: string
  status: string
}

export interface TransactionTransfer {
  id: string
  admin: TransactionTransferAdmin
  changes: TransactionTransferChanges
  createdAt: string
  fromTransaction: TransactionTransferTransaction
  reason: string
  toTransaction: TransactionTransferTransaction
}

export interface TransactionTransfersResponse {
  data: TransactionTransfer[]
  meta: {
    message: string
    errors: unknown[]
  }
}

export function getTransactionTransfersAction(transactionCuid: string): Promise<TransactionTransfersResponse> {
  return api.v2.get<TransactionTransfersResponse>(`/transactions/${transactionCuid}/transfers`)
}
